module.exports = __webpack_public_path__ + "img/transportation_white.ea17cbb5.svg";